import { SortFilter } from '../SortFilter';

export const taskManagment = (function () {
  const clickTaskHandler = (task) => {
    const linkObject = task.linkObject;
    // Set Filter
    const filter = [
      {
        displayName: linkObject.filterItem.displayName,
        filterTypeName: linkObject.filterItem.filterTypeName,
        internalName: linkObject.filterItem.internalName,
        values: [{ name: linkObject.objectId, value: linkObject.objectId }]
      }
    ];

    SortFilter.setFilters(linkObject.requestPage.toLowerCase(), filter);
  };

  return {
    clickTaskHandler
  };
})();
